<script lang="ts">
    
    import { Badge } from "sveltestrap";
    import type { AllowedGames } from "../../Model/AllowedGames";
    import Watch from "../Watch.svelte";

    export let allowedGames: AllowedGames;

</script>

<Watch state={allowedGames.bingo90} let:value>
    {#if value}
        <Badge color="secondary">Binfun 90</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.bingo75} let:value>
    {#if value}
        <Badge color="secondary">Binfun 75</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.bingoMex} let:value>
    {#if value}
        <Badge color="secondary">Lotería mexicana</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.bingoAnimals} let:value>
    {#if value}
        <Badge color="secondary">Binfun Animales</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.bingoCartoon} let:value>
    {#if value}
        <Badge color="secondary">Binfun Caricaturas</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.movies} let:value>
    {#if value}
        <Badge color="secondary">Binfun Películas</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.moviesKids} let:value>
    {#if value}
        <Badge color="secondary">Binfun Películas Kids</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.xmas} let:value>
    {#if value}
        <Badge color="secondary">Binfun X-Mas</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.football} let:value>
    {#if value}
        <Badge color="secondary">Binfun Football</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.halloween} let:value>
    {#if value}
        <Badge color="secondary">Binfun Halloween</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.superheroes} let:value>
    {#if value}
        <Badge color="secondary">Binfun Superheroes</Badge>
    {/if}
</Watch>

<Watch state={allowedGames.cartoon} let:value>
    {#if value}
        <Badge color="secondary">Binfun Cartoon</Badge>
    {/if}
</Watch>